import input from './input'
import inputMax from './inputMax'
import inputLimit from "./inputLimit";
import timeout from "./timeout";
export default {
  input,
  inputMax,
  inputLimit,
  timeout
}